module.exports = __webpack_public_path__ + "static/dsc-0837@3x-43cd76d62a2ebd05ef2317610bc90877.png";